import { useMediaQuery } from "./useMediaQuery";

export const useIsDesktopMediaQuery = () => {
	const isDesktop = useMediaQuery("(min-width: 720px)");
	return isDesktop;
};
